module.exports = __webpack_public_path__ + "3c95a47d3eb661c95285a9cad2ca157a.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img14.png
// module id = 1320
// module chunks = 0